import type React from 'react';
import './style.scss';
import { Box, Heading, List, Paragraph } from '@zillow/constellation-10';
import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';
import DebouncedButton from '@common/components/ConstellationDebouncedButton';
import IreneOnboardingCSEvents from '@rental-manager/tracking/OnboardingClickStreamEvents';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

interface Props {
  onSubmit: () => void;
  onClose: () => void;
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
}

const Checklist: React.FC<Props> = ({ onSubmit, onClose, user, currentProperty }) => {
  const handleSubmit = (): void => {
    IreneOnboardingCSEvents.emitContinueFromChecklistPageEvent({ currentProperty, user });
    return onSubmit();
  };

  const handleClose = (): void => {
    IreneOnboardingCSEvents.emitExitFromOnboardingFlowEvent({
      currentProperty,
      user,
      triggerObject: 'checklist',
    });
    onClose();
  };

  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={handleClose}
      header={
        <Box css={{ padding: 'token(spacing.sm) !important', textAlign: 'center' }}>
          <Heading level={3} textStyle="heading-xs">
            Payment setup
          </Heading>
        </Box>
      }
      body={
        <Box
          css={{
            padding: 'token(spacing.lg) !important',
          }}
        >
          <Box>
            <Paragraph textStyle="body-lg-bold">Here&apos;s what you&apos;ll need</Paragraph>
          </Box>
          <Box>
            <List.Root appearance="bullet">
              <List.Item>Bank account info for where you&apos;d like to receive payments</List.Item>
              <List.Item>Amounts for the monthly rent and any move-in charges</List.Item>
              <List.Item>Basic details about your renter</List.Item>
              <List.Item>
                Your Social Security number and/or Employer Identification Number (EIN), plus a physical mailing address
              </List.Item>
            </List.Root>
          </Box>
        </Box>
      }
      footer={
        <Box css={{ padding: 'token(spacing.sm) !important' }}>
          <DebouncedButton onClick={handleSubmit}>Ok, got it</DebouncedButton>
        </Box>
      }
    />
  );
};

export default Checklist;
